export default __webpack_public_path__ + "static/media/exposure_s.cc057132.jpg";